import { Selector } from "@ngxs/store";
import { PayoutState, PayoutStateModel } from "./payout.state";

export class PayoutSelector {
    @Selector([PayoutState])
    static isLoading(state: PayoutStateModel): boolean {
        return state.loading;
    }

    @Selector([PayoutState])
    static getPayouts(state: PayoutStateModel) {
        return state.payouts;
    }
    @Selector([PayoutState])
    static getPayoutDetails(state: PayoutStateModel) {
        return state.payoutDetails;
    }
    @Selector([PayoutState])
    static getPayoutOrganizerAvailable(state: PayoutStateModel) {
        return state.payoutAvailable;
    }
}